// var EventType =  require('../../constants/event-type.js');
// var Header = require('./header/header.jsx');
// var Content = require('./content.jsx');
// var StudioModels = require('../../models/studio-models.js');
// var IdentityAccessService = require('../../../../core/services/identity-access-service.js');
// var InternalEventBus = require('../../../../core/utils/internal-event-bus.js');
// var InternalEvent = require('../../../../core/constants/internal-event.js');

import BaseComponent from "../../baseComponent.js";
import Header from "./header/header.jsx";
import Content from "./content.jsx";
require('../spreadsheet/functions/functions.js');

export default class Editor extends BaseComponent {
  constructor(props) {
    super(props);
    let pos = window.location.href.indexOf("/analyticsStudio/");
    this.studioId = window.location.href.substring(pos + 17, 100).split("/")[0];
    this.studios = require('../demo-studio-data.js');
  }

  componentDidMount() {
    let previousValue = "";
    let that = this;
    $("div.inline-editable")
      .on("click", function () {
        if ($(this).attr("contenteditable") !== "true") {
          previousValue = $(this).text();
          $(this).attr("contenteditable", true).focus();
          //if ($(this).text() === "TITLE") $(this).selectText();
        }
      })
      .on("keydown", function (e) {
        let key = e.which;
        if (key === 13) {
          apply(this);
        } else if (key === 27) {
          $(this).text(previousValue);
          reset(this);
        }
      })
      .focusout(function () {
        apply(this);
      });

    function apply(element) {
      if ($(element).text().trim() === "") {
        $(element).text(previousValue);
      } else {
        localStorage.setItem("StudioTitle-" + that.props.title, $(element).text());
      }
      reset(element);
    }

    function reset(element) {
      $(element).attr("contenteditable", false);
    }
  }

  render() {
    let studio;

    for (let i = 0; i < this.studios.length; i++) {
      if(this.studios[i] != null) {
        if (this.studios[i].id == this.studioId) {
          studio = this.studios[i];
        }
      }
    }

    return (
      <div className="studio-container">
        <Header title={studio.title}></Header>
        <Content studioId={this.studioId} studio={studio} completers={this.completers}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/editor.jsx